

export default () => {
    /**
    * Set class when header is fixed
    * @param {*} ev 
    */

    foundedStores();
    customizedSearchStore();
    
}

function customizedSearchStore(){
    let fakeSearchBtn = document.querySelector('#wpsl-search-wrap .arrow-button');
    let realSearchBtn = document.getElementById('wpsl-search-btn');
    if(fakeSearchBtn !== null && realSearchBtn !== null){
        fakeSearchBtn.addEventListener('click', event => {
            event.stopPropagation();
            realSearchBtn.click();
        });
    }
}

function foundedStores(){
    let storeFound = document.getElementById('store-found');
    let storeList = document.getElementById('wpsl-stores');
    if(storeFound !== null && storeList !== null){
        storeFound.querySelector('span')
        let amountOfStores = 0;
        if(storeList){
            storeList.addEventListener('DOMSubtreeModified', (el) => {
                if(el){
                    amountOfStores = storeList.querySelectorAll('li').length;
                    setStoreAmount(storeFound, amountOfStores);
                }
            });    
        }
        setStoreAmount(storeFound, 'loading');
    }
}

function setStoreAmount(el, items){
    if(el !== null && typeof el !== 'undefined'){
        el.style.visibility = 'hidden';
        if(items === 'loading'){
            el.innerHTML = '';
        }
        else if(parseInt(items) > 0){
            let label = el.getAttribute('data-multiple');
            if(parseInt(items) === 1){
                label = el.getAttribute('data-single');
            }
            if(label.trim() !== ''){
                el.innerHTML = '<span>' + items + '</span> ' + label;
            }
            el.style.visibility = 'visible';
        } else if(parseInt(items) >= 0) {
            let noResultsLabel = el.getAttribute('data-not-found');
            if(noResultsLabel.trim() !== ''){
                el.innerHTML = noResultsLabel;
            }
            el.style.visibility = 'visible';
        }
    }
}

